import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isCollapsed", "indeterminateState", "setIsCollapsed", "className"];
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';
import { BiSort } from "@react-icons/all-files/bi/BiSort.esm.js";
import { BsChevronDown } from "@react-icons/all-files/bs/BsChevronDown.esm.js";
import { BsChevronExpand } from "@react-icons/all-files/bs/BsChevronExpand.esm.js";
import { BsChevronUp } from "@react-icons/all-files/bs/BsChevronUp.esm.js";
import { wrap } from '@unmapped/core/utils';
import useStyleOverride from "../../hooks/useStyleOverride.js";
import useSort from '@unmapped/core/hooks/useSort';
import baseStyles from "./styles.module.css.js";
export var SortIndicator = observer(wrap((_ref, ref) => {
  var {
      isCollapsed = false,
      indeterminateState = false,
      setIsCollapsed,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyleOverride('results/SortIndicator', baseStyles);
  var [sort, updateSort] = useSort();
  useEffect(() => {
    if (sort.direction === null && !indeterminateState) updateSort({
      direction: 'desc'
    });
  }, [indeterminateState, sort.direction]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(styles.SortIndicator, isCollapsed && styles.collapse, className),
    ref: ref
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: styles.SortIndicator__Label
  }, "Sort By: ", sort.label), /*#__PURE__*/React.createElement("div", {
    className: styles.SortIndicator__Icon,
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      if (isCollapsed && setIsCollapsed) {
        setIsCollapsed(false);
      } else if (sort.direction === null) updateSort({
        direction: 'desc'
      });else if (sort.direction === 'desc') updateSort({
        direction: 'asc'
      });else updateSort({
        direction: indeterminateState ? null : 'desc'
      });
    }
  }, isCollapsed && /*#__PURE__*/React.createElement(BiSort, {
    size: 12
  }), !isCollapsed && sort.direction === null && /*#__PURE__*/React.createElement(BsChevronExpand, {
    size: 12
  }), !isCollapsed && sort.direction === 'asc' && /*#__PURE__*/React.createElement(BsChevronUp, {
    size: 12
  }), !isCollapsed && sort.direction === 'desc' && /*#__PURE__*/React.createElement(BsChevronDown, {
    size: 12
  })));
}, 'SortIndicator'));
export default SortIndicator;
//# sourceMappingURL=index.js.map